import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useOrderList = ({
  type,
  search,
  page,
  orderFilter,
  myBranchesFilter,
  showApprovals,
}) => {
  let orderBranch = orderFilter;
  if (orderFilter === "All" && myBranchesFilter !== "All")
    orderBranch = myBranchesFilter;

  const filter = {
    filter: {
      noFilter: null,
      branchFilter: orderBranch,
    },
    paging: { pageIndex: page },
  };

  // Switch path on page type
  let path = "draftorderlist";
  switch (type) {
    case "draft":
      path = "draftorderlist";
      filter.filter.Approvals = showApprovals === "All" ? null : showApprovals;
      filter.filter.searchTerm = search;
      break;
    case "received":
      path = "orderlist";
      filter.filter.searchTerm = search;
      break;
    case "completed":
      path = "completeorderlist";
      filter.filter.searchTerm = search;
      break;
    case "approved-orders":
      path = "orderlist";
      filter.filter.searchTerm = search;
      break;
    case "approved-invoices":
      path = "completeorderlist";
      filter.filter.searchTerm = search;
      break;
  }

  return useQuery({
    queryKey: ["orderListState", type, filter],
    queryFn: async () =>
      callApi({
        path: path,
        command: "",
        data: JSON.stringify({ list: filter }),
      }),
    placeholderData: keepPreviousData,
    staleTime: 5000,
  });
};
